import React from 'react';
import Box from './Box';
import styles from '../styles/components/InfoBox.module.css';

export interface InfoBoxProps {
  header: string;
  text: JSX.Element;
}

const InfoBox: React.FC<InfoBoxProps> = ({ header, text }) => {
  return (
    <Box>
      <div className={styles.infoBox}>
        <h3 className={styles.infoBoxHeader}>{header}</h3>
        <div className={styles.infoBoxText}>{text}</div>
      </div>
    </Box>
  );
};

export default InfoBox;
